import { render, staticRenderFns } from "./GlicemiaMeasurements.vue?vue&type=template&id=449fc3a4&scoped=true"
import script from "./GlicemiaMeasurements.vue?vue&type=script&lang=js"
export * from "./GlicemiaMeasurements.vue?vue&type=script&lang=js"
import style0 from "./GlicemiaMeasurements.vue?vue&type=style&index=0&id=449fc3a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449fc3a4",
  null
  
)

export default component.exports